var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center animation-opacity"},[_c('div',[_c('h1',{staticClass:"app-title"},[_vm._v(" "+_vm._s(_vm.smsLoaderData))]),_c('div',{staticClass:"text-center mt-1"},[_c('v-progress-circular',{staticClass:"color-icon",attrs:{"size":30,"width":7,"indeterminate":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }